module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rows rows-contenant"
  }, _vm._l((_vm.contenants.filtredContenants), function(contenant) {
    return _c('div', {
      key: contenant.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Numéro du contenant")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(contenant.reference))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Type")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(_vm._f("collecteType")(contenant.typeContenant)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Arrondissement / Secteur")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(_vm._f("arrondissementName")(contenant.arrondissement_id)) + " / " + _vm._s(_vm._f("secteurName")(contenant.secteur_id)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 adresse"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Adresse")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(contenant.adresse))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Nombre de collectes")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(contenant.nombreDeCollecte ? contenant.nombreDeCollecte : 0) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Moyenne")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(contenant.tauxDeRemplissage) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 last-date-collecte"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Dernière collecte")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(_vm.formatDate(contenant.lastModif)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "actions-contenants"
    }, [_c('a', {
      staticClass: "action-edit",
      on: {
        "click": function($event) {
          return _vm.$emit('edit', contenant)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/img/edit-icon.svg")
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "action-delete right-separator",
      on: {
        "click": function($event) {
          return _vm.$emit('delete', contenant)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../../static/img/delete-icon.svg")
      }
    })])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c2a3421!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/collecte/CollectesList.vue
// module id = 2108
// module chunks = 2